import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./SearchResults.scss";
import moment from "moment";
import { getNavigationUrl } from "../../services/encounterNavigationService";

export const SearchResults = ({ results ,resetSearchText}) => {
    const resultClicked =()=>{
        setSearchResults(null)
        resetSearchText();

    }
    const [searchResults, setSearchResults] = useState(null);
    useEffect(() => {
        setSearchResults(results);
    }, [results]);
    
    return (    
        <div className="search-results" onClick={resultClicked}>
            {searchResults?.length ? (
                <div className="search-results__list">
                    {searchResults.map((result, i) => (
                        <Link
                            to={getNavigationUrl({
                                globalId: result.encounterId,
                                status: result.encounterStatus,
                            })}
                            className="search-results__item"
                            key={i}
                        >
                            <div className="search-results__item-inner">
                                <h4>
                                    {result.firstName} {result.lastName}
                                </h4>
                                <div>
                                    <span className="search-results__dob">
                                        <span className="h5">DOB </span>{" "}
                                        <span className="p-regular">
                                            {moment(result.dateOfBirth).format("MMM Do, YYYY")}
                                        </span>
                                    </span>
                                    <span>
                                        <span className="h5">SSN </span>
                                        <span className="p-regular">
                                            {!!!result.socialSecurityNumber && `no SSN`}
                                            {result.socialSecurityNumber &&
                                                `xxx-xx-${result.socialSecurityNumber.substr(
                                                    result.socialSecurityNumber.length - 4
                                                )}`}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            ) : (
                <div className="search-results__none">
                    <h4>0 results found</h4>
                </div>
            )}
        </div>
    );
};
